import React, { useEffect, useState } from 'react'
import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Skeleton, TextField, Typography } from "@mui/material"
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { ArrowsClockwise, SpinnerGap, StarFour } from '@phosphor-icons/react';
import { generateQuestion } from '../../../store/course/courseBaseApi'
import { create } from '../../../store/questionBank/questionBankBaseApi';
import { toast } from 'react-toastify';
import { generateConstants as constants } from './constants'
import { parseContentToParagraph, parseKeywords } from '../../../components/markupEditor';
import { useCourse } from '../hooks';


const GenerateQuestion = ({ handleClose, chapterId, sectionId }) => {

    const { lessonPlan } = useCourse();
    const [sectionData, setSectionData] = useState();
    const [chapterData, setChapterData] = useState();
    const [isGenerating, setIsGenerating] = useState(false);
    const [contentDetails, setContentDetails] = useState({});
    const [generatedQues, setGeneratedQues] = useState([]);
    const [question, setQuestion] = useState([]);
    const [disableAddQues, setDisableAddQues] = useState(false);

    useEffect(() => {
        if (lessonPlan) {
            const _section = lessonPlan?.sections?.find((sec) => sec.sectionId === sectionId);
            if (_section) {
                setSectionData(_section)
                const _chapter = _section?.chapters?.find((chap) => chap.chapterId === chapterId);
                setChapterData(_chapter)
            }
        }
    }, [lessonPlan])
    useEffect(() => {
        if (chapterData?.content) {
            let parsedParagraph = parseContentToParagraph(chapterData?.content);
            let parsedKeywords = parseKeywords(chapterData?.keyWords);
            let wordsCount = calculateWordCount(parsedParagraph) || calculateWordCount(chapterData?.content);
            setContentDetails({
                ...contentDetails,
                sample_passage: parsedParagraph || chapterData?.content,
                lexemes: parsedKeywords || chapterData?.keyWords,
                total_words: wordsCount || 0,
            })
        }
    }, [chapterData?.content]);

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setContentDetails((prev) => ({ ...prev, [name]: value }));
    }

    const handleGenerateClick = async () => {
        setDisableAddQues(false)
        setIsGenerating(true);

        let validation = (contentDetails?.demography && contentDetails?.chatKey && contentDetails?.generation && contentDetails?.grade && contentDetails?.interest && contentDetails?.level && contentDetails?.numOfQuestions && contentDetails?.sample_questions && contentDetails?.topic) ? true : false

        if (!validation) {
            setIsGenerating(false)
            toast.warn('Please fill up all the fields')
            return
        }

        // setIsGenerating(true);
        setGeneratedQues([]); // Reset previous questions
        let body = {
            "courseCode": lessonPlan?.courseCode,
            "courseId": lessonPlan?.courseId,
            "sectionId": sectionData?.sectionId,
            "chapterId": chapterData?.chapterId,
            "chatKey": contentDetails?.chatKey,
            "category": contentDetails?.category,
            "taxonomy": contentDetails?.taxonomy,
            "inputs": {
                "demography": contentDetails?.demography,
                "generation": contentDetails?.generation,
                "grade": contentDetails?.grade,
                "interest": contentDetails?.interest,
                "learning_outcome": contentDetails?.learningOutcome,
                "level": contentDetails?.level,
                "lexemes": contentDetails?.lexemes,
                "num_of_questions": contentDetails?.numOfQuestions,
                "sample_passage": contentDetails?.sample_passage,
                "sample_questions": contentDetails?.sample_questions,
                "topics": contentDetails?.topic,
                "total_words": contentDetails?.total_words
            }
        }
        try {
            // Call API
            const resp = await generateQuestion(body);
            const questionList = resp?.response?.questions;

            if (questionList && questionList.length > 0) {
                const updatedData = questionList.map(({ questionId, ...rest }) => rest);
                setGeneratedQues(updatedData);
                toast.success('Questions generated successfully!');
            } else {
                toast.info('No questions were generated. Please check the inputs and try again.');
            }
        } catch (error) {
            console.error("Error generating questions:", error);
            toast.error('Failed to generate questions. Please try again later.');
        } finally {
            setIsGenerating(false);
        }
        // let resp = await generateQuestion(body)
        // console.log("questionList", resp?.response?.questions);
        // let updatedData = resp?.response?.questions.map(obj => {
        //     let { questionId, ...rest } = obj;
        //     return rest;
        // });
        // setGeneratedQues(updatedData)
        // if (updatedData) {
        //     setIsGenerating(false);
        // }
        // setTimeout(() => {
        //     // setGeneratedQues(question);
        //     setIsGenerating(false);
        // }, 10000);
    };

    const addQuestion = () => {
        generatedQues.map((question, index) => {
            let quesData = {
                status: question?.status,
                courseId: question?.courseId,
                sectionId: question?.sectionId,
                chapterId: question?.chapterId,
                // groupDetails: question?.groupDetails,
                type: question?.type,
                category: question?.category,
                taxonomy: question?.taxonomy,
                answerDetails: {
                    options: {
                        values: question?.answerDetails?.options?.values,
                        answerLabels: question?.answerDetails?.options?.answerLabels,
                        helpText: question?.answerDetails?.options?.helpText,
                        answerKey: question?.answerDetails?.options?.answerKey,
                        marks: question?.answerDetails?.options?.marks
                    },
                },
                questionDetails: question?.questionDetails
            }
            create(quesData);
        })
        setDisableAddQues(true);
        toast.success('Added to question bank Successfully')
    }

    const calculateWordCount = (text) => {
        return text ? text.trim().split(/\s+/).length : 0;
    };

    return (
        <Box>
            <Typography
                align="left"
                variant="h1"
                color="primary.blue"
                sx={{
                    margin: '0',
                    fontWeight: '700',
                    lineHeight: '1.5',
                    fontSize: '2rem',
                    display: 'flex',
                    gap: '20px',
                    alignItems: 'center'
                }}>{'Generate Question'} <AutoAwesomeOutlinedIcon /> </Typography>
            <Grid sx={styles.gridContainer} container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel style={styles.inputLabel}>Grade <span style={{ color: 'red' }}>*</span></InputLabel>
                    <FormControl fullWidth>
                        <Select
                            name="grade"
                            placeholder="Grade"
                            value={contentDetails?.grade || ''}
                            sx={{ height: '47px' }}
                            onChange={handleOnChange}
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            {Object.entries(constants.GRADES).map(([key, value], i) => (
                                <MenuItem key={i} value={key}>{value}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel style={styles.inputLabel}>Generation <span style={{ color: 'red' }}>*</span></InputLabel>
                    <FormControl fullWidth>
                        <Select
                            name="generation"
                            placeholder="Generation"
                            value={contentDetails?.generation || ''}
                            sx={{ height: '47px' }}
                            onChange={handleOnChange}
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            {constants.GENERATION.map((item, index) => (
                                <MenuItem key={index} value={item}>{item}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel style={styles.inputLabel}>Level <span style={{ color: 'red' }}>*</span></InputLabel>
                    <FormControl fullWidth>
                        <Select
                            name="level"
                            placeholder="Level"
                            value={contentDetails?.level || ''}
                            sx={{ height: '47px' }}
                            onChange={handleOnChange}
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            {constants.QUESTION_LEVELS.map((item, index) => (
                                <MenuItem key={index} value={item}>{item}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel style={styles.inputLabel}>Category <span style={{ color: 'red' }}>*</span></InputLabel>
                    <FormControl fullWidth>
                        <Select
                            name="category"
                            placeholder="Category"
                            value={contentDetails?.category || ''}
                            sx={{ height: '47px' }}
                            onChange={handleOnChange}
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            {constants.CATEGORY.map((item, index) => (
                                <MenuItem key={index} value={item}>{item}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel style={styles.inputLabel}>Taxonomy <span style={{ color: 'red' }}>*</span></InputLabel>
                    <FormControl fullWidth>
                        <Select
                            name="taxonomy"
                            placeholder="Taxonomy"
                            value={contentDetails?.taxonomy || ''}
                            sx={{ height: '47px' }}
                            onChange={handleOnChange}
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            {constants.TAXONOMY.map((item, index) => {
                                return <MenuItem key={index} value={item}>{item}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel style={styles.inputLabel}>Demography <span style={{ color: 'red' }}>*</span></InputLabel>
                    <FormControl fullWidth>
                        <Select
                            name="demography"
                            placeholder="Demography"
                            value={contentDetails?.demography || ''}
                            sx={{ height: '47px' }}
                            onChange={handleOnChange}
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            {Object.entries(constants.DEMOGRAPHY).map(([key, value], i) => (
                                <MenuItem key={i} value={key}>{value}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel style={styles.inputLabel}>Topic <span style={{ color: 'red' }}>*</span></InputLabel>
                    <TextField
                        name="topic"
                        fullWidth
                        type="text"
                        value={contentDetails?.topic || ''}
                        onChange={handleOnChange}
                        placeholder="Enter Topic"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel style={styles.inputLabel}>Key <span style={{ color: 'red' }}>*</span></InputLabel>
                    <TextField
                        name="chatKey"
                        fullWidth
                        type="text"
                        value={contentDetails?.chatKey || ''}
                        onChange={handleOnChange}
                        placeholder="Key"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel style={styles.inputLabel}>Interest <span style={{ color: 'red' }}>*</span></InputLabel>
                    <TextField
                        name="interest"
                        fullWidth
                        type="text"
                        value={contentDetails?.interest || ''}
                        onChange={handleOnChange}
                        placeholder="Interest"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel style={styles.inputLabel}>Number Of Questions <span style={{ color: 'red' }}>*</span></InputLabel>
                    <TextField
                        name="numOfQuestions"
                        fullWidth
                        type="number"
                        value={contentDetails?.numOfQuestions || ''}
                        onChange={handleOnChange}
                        placeholder="Number Of Questions"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel style={styles.inputLabel}>Total Words</InputLabel>
                    <TextField
                        name="total_words"
                        fullWidth
                        type="number"
                        value={contentDetails?.total_words || ''}
                        onChange={''}
                        placeholder="Total Words"
                        disabled
                    />
                </Grid>
                <Grid item xs={12}>
                    <InputLabel style={styles.inputLabel}>Learning Outcome <span style={{ color: 'red' }}>*</span></InputLabel>
                    <FormControl fullWidth>
                        <TextField
                            name="learningOutcome"
                            value={contentDetails?.learningOutcome || ''}
                            onChange={handleOnChange}
                            fullWidth
                            multiline
                            rows={1}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel style={styles.inputLabel}>Content</InputLabel>
                    <FormControl fullWidth>
                        <TextField
                            name="sample_passage"
                            value={contentDetails?.sample_passage || ''}
                            disabled
                            fullWidth
                            multiline
                            rows={3}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel style={styles.inputLabel}>Keywords <span style={{ color: 'red' }}>*</span></InputLabel>
                    <FormControl fullWidth>
                        <TextField
                            name="lexemes"
                            value={contentDetails?.lexemes || ''}
                            // disabled
                            fullWidth
                            multiline
                            onChange={handleOnChange}
                            rows={3}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel style={styles.inputLabel}>Sample question <span style={{ color: 'red' }}>*</span></InputLabel>
                    <FormControl fullWidth>
                        <TextField
                            name="sample_questions"
                            value={contentDetails?.sample_questions || ''}
                            onChange={handleOnChange}
                            fullWidth
                            multiline
                            rows={2}
                        />
                    </FormControl>
                </Grid>
                {isGenerating ? (
                    <Grid item xs={12}>
                        <Typography sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '5px', marginBottom: '10px', fontWeight: 600 }} ><AutoAwesomeOutlinedIcon sx={styles.animatedIcon} />Generating Questions<span style={styles.dots}>...</span></Typography>
                        <Stack sx={styles.skeletonContainer} spacing={2}>
                            <Skeleton variant="rectangular" sx={styles.skeletonGrey} />
                            <Skeleton variant="rectangular" sx={styles.skeletonWhite} />
                            <Skeleton variant="rectangular" sx={styles.skeletonWhite} />
                            <Skeleton variant="rectangular" sx={styles.skeletonWhite} />
                            <Skeleton variant="rectangular" sx={styles.skeletonWhite} />
                        </Stack>

                    </Grid>
                ) : (
                    <>
                        {generatedQues.length > 0 &&
                            <Grid item xs={12}>
                                <Typography sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: '5px', marginBottom: '10px', fontWeight: 600 }} ><AutoAwesomeOutlinedIcon sx={styles.animatedIcon} />Generated Questions<span style={styles.dots}>...</span></Typography>
                            </Grid>
                        }
                        {generatedQues.map((question, index) => (
                            <Grid item xs={12} key={index}>
                                <Box sx={styles.generatedQuestion}>
                                    <Typography style={styles.question}>{index + 1}.{question?.questionDetails?.text}</Typography>
                                    {question?.answerDetails?.options?.values.map((ans, ansIndex) => {
                                        // Check if the current label is in the answerLabels array
                                        const isCorrect = question?.answerDetails?.options?.answerLabels.includes(ans.label);
                                        return (
                                            <Typography
                                                style={isCorrect ? styles.correctAnswer : styles.answer}
                                                key={ansIndex}
                                            >
                                                {`${ans.label}. ${ans?.value?.text}`}
                                            </Typography>
                                        );
                                    })}
                                </Box>
                            </Grid>
                        ))}
                    </>)}
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: `${generatedQues.length > 0 ? 'space-between' : 'flex-end'}`, alignItems: 'center' }}>
                {generatedQues.length > 0 &&
                    <Button size='large' disabled={disableAddQues} variant="contained" onClick={addQuestion} color="primary">Add Questions</Button>
                }
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}>
                    <Button size='large' variant="outlined" onClick={handleClose} color="primary">Cancel</Button>
                    <Button
                        sx={isGenerating ? { ...styles.btnAnimation } : {}}
                        size='large'
                        variant="contained"
                        color="primary"
                        onClick={handleGenerateClick}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                            <SpinnerGap size={24} style={{ animation: isGenerating ? 'rotate 1s linear infinite' : 'none', }} />
                            {isGenerating ? 'Generating' : (generatedQues.length > 0 ? 'Regenerate' : 'Generate')}
                        </Box>
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default GenerateQuestion

const styles = {
    container: {
        border: 'none'
    },
    label: {
        color: 'var(--mui-palette-common-black)',
        fontWeight: 'bold'
    },
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'

    },
    gridContainer: {
        my: 2,
    },
    closeModal: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
    },
    btnAnimation: {
        background: 'linear-gradient(270deg, violet, var(--mui-palette-primary-main))',
        backgroundSize: '400% 400%',
        animation: 'gradientAnimation 10s ease infinite',
        color: '#fff', // Make sure text is readable over the gradient
        padding: '10px 20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textTransform: 'none',
    },
    skeletonContainer: {
        width: '100%',
    },
    skeletonGrey: {
        backgroundColor: '#e0e0e0', // Grey background
        width: '80%',
        height: 30,
        borderRadius: 1,
    },
    skeletonWhite: {
        backgroundColor: '#e0e0e0',
        width: '50%',
        height: 20,
        borderRadius: 5,
    },
    generatedQuestion: {
        // backgroundColor: '#f0f0f0',
        padding: '10px',
        borderRadius: '5px',
    },
    dots: {
        display: 'inline-block',
        animation: 'dots 8s steps(5, end) infinite',
    },
    animatedIcon: {
        animation: 'gradientColor 3s linear infinite',
        fill: 'url(#gradient)', // Use fill instead of background
        fontSize: '2rem',
    },
    question: {
        backgroundColor: '#cbd5e2',
        width: '100%',
        height: 30,
        borderRadius: '10px',
        marginBottom: '10px',
        padding: "10px 10px"
    },
    answer: {
        backgroundColor: '#e0e0e0',
        width: '70%',
        height: 20,
        borderRadius: '10px',
        marginBottom: '10px',
        padding: "10px 30px"
    },
    correctAnswer: {
        backgroundColor: '#b2f793', // Light grey shade for correct answers
        width: '70%',
        height: 20,
        borderRadius: '10px',
        marginBottom: '10px',
        padding: '10px 30px',
    },
};

// Inject keyframes for button background animation and loop icon rotation
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(`
  @keyframes gradientAnimation {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`, styleSheet.cssRules.length);

styleSheet.insertRule(`
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, styleSheet.cssRules.length);

styleSheet.insertRule(`
  @keyframes gradientColor {
    0% { fill: violet; }
    50% { fill: var(--mui-palette-primary-main); }
    100% { fill: violet; }
  }
`, styleSheet.cssRules.length);